import React, { FC } from "react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

interface ViewDetailsActionProps {
  url: string;
  id: number;
}

export const ViewDetailsAction: FC<ViewDetailsActionProps> = ({ url, id }) => {
  return (
    <Link to={`${url}/${id}`} data-toggle="tooltip" data-placement="top" title="Details">
      <svg
        width="26"
        height="26"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="30" height="30" rx="8" fill="#E7F8F0" />
        <path
          d="M13.8327 15.3333C13.8327 14.5049 14.5043 13.8333 15.3327 13.8333C16.1611 13.8333 16.8327 14.5049 16.8327 15.3333C16.8327 16.1618 16.1611 16.8333 15.3327 16.8333C14.5043 16.8333 13.8327 16.1618 13.8327 15.3333Z"
          fill="#12B76A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.66602 15.3333C8.66602 16.4263 8.94933 16.7943 9.51594 17.5304C10.6473 19.0003 12.5448 20.6667 15.3327 20.6667C18.1206 20.6667 20.018 19.0003 21.1494 17.5304C21.716 16.7943 21.9993 16.4263 21.9993 15.3333C21.9993 14.2404 21.716 13.8724 21.1494 13.1362C20.018 11.6664 18.1206 10 15.3327 10C12.5448 10 10.6473 11.6664 9.51594 13.1362C8.94933 13.8724 8.66602 14.2404 8.66602 15.3333ZM15.3327 12.8333C13.952 12.8333 12.8327 13.9526 12.8327 15.3333C12.8327 16.714 13.952 17.8333 15.3327 17.8333C16.7134 17.8333 17.8327 16.714 17.8327 15.3333C17.8327 13.9526 16.7134 12.8333 15.3327 12.8333Z"
          fill="#12B76A"
        />
      </svg>
    </Link>
  );
};